export enum DocumentsCreateNewFolderActionTypes {
  CREATE_DOCUMENTS_NEW_FOLDER = 'CREATE_DOCUMENTS_NEW_FOLDER',
  OPEN_DOCUMENTS_CREATE_NEW_FOLDER = 'OPEN_DOCUMENTS_CREATE_NEW_FOLDER',
  CLOSE_DOCUMENTS_CREATE_NEW_FOLDER = 'CLOSE_DOCUMENTS_CREATE_NEW_FOLDER',
}